import React from 'react';

import { useI18n } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import { IInfoTableCell } from 'types/info-table';
import { Email } from 'components/organisms/tep/tep-management/modals/issue-modal/cells/email';
import { Since } from 'components/organisms/tep/tep-management/modals/issue-modal/cells/since';
import { Until } from 'components/organisms/tep/tep-management/modals/issue-modal/cells/until';
import { Actions } from 'components/organisms/tep/tep-management/modals/issue-modal/cells/actions';
import { PlateNumber } from 'components/organisms/tep/tep-management/modals/issue-modal/cells/plate-number';

export const useIssueColumns = () => {
  const { fc } = useI18n();

  const getEmailCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <Email entryPass={cell.row} />;

  const getPlateNumberCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <PlateNumber entryPass={cell.row} />;

  const getSinceCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <Since entryPass={cell.row} />;

  const getUntilCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <Until entryPass={cell.row} />;

  const getActionsCell = (cell: IInfoTableCell<ITepEntryPass, string>) => <Actions entryPass={cell.row} />;

  return [
    {
      header: fc('name'),
      accessorKey: 'name',
      cell: (cell: IInfoTableCell<ITepEntryPass, string>) => <div>{cell.row.name}</div>,
      width: 100,
      minWidth: 100,
    },
    {
      header: fc('IMEI'),
      accessorKey: 'uri',
      cell: (cell: IInfoTableCell<ITepEntryPass, string>) => <div>{cell.row.device.uri}</div>,
      minWidth: 160,
    },
    {
      header: fc('company'),
      accessorKey: 'company',
      cell: (cell: IInfoTableCell<ITepEntryPass, string>) => <div>{cell.row.lease?.company || '-'}</div>,
      minWidth: 120,
    },

    { header: fc('emails'), accessorKey: 'email', cell: getEmailCell, minWidth: 120 },
    { header: fc('Vehicle Plate No'), accessorKey: 'plateNumber', cell: getPlateNumberCell, minWidth: 120 },
    { header: fc('TEP Start'), accessorKey: 'startOn', cell: getSinceCell, minWidth: 120 },
    { header: fc('TEP End'), accessorKey: 'endOn', cell: getUntilCell, minWidth: 120 },
    { accessorKey: 'actions', header: fc('actions'), cell: getActionsCell, width: 130, minWidth: 130 },
  ];
};
